const messages = {
  invalidPonits: "Points must should between 2 to 1000",
};

export default messages;
